import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import WarehouseGoodsIssueContainer from 'app/containers/InventoryManagement/WarehouseGoodsIssue'

const WarehouseGoodsIssueContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <WarehouseGoodsIssueContainer />
    </>
  )
}
const WarehouseGoodsIssueContainerPage = memo(
  WarehouseGoodsIssueContainerPageCpn,
  isEqual,
)

export default WarehouseGoodsIssueContainerPage
